export function isInsideTV(): boolean {
    if (typeof navigator === 'undefined' || !navigator.userAgent) return false;

    const userAgent = navigator.userAgent.toLowerCase();

    // Common TV platforms and browsers
    const tvPlatforms = [
        'tv',
        'smart-tv',
        'smarttv',
        'opera tv',
        'webos',
        'tizen',
        'vidaa',
        'netcast',
        'nettv',
        'viera',
        'hbbtv',
        'roku',
        'androidtv',
        'googletv',
        'appletv',
        'tvos',
        'firetv',
        'android'
    ];

    return tvPlatforms.some(platform => userAgent.includes(platform));
}